export class GameConstants {
    static readonly BLOCKED_SYMBOL_ID = 31;
    static readonly MINI_SYMBOL_ID = 26;
    static readonly MINOR_SYMBOL_ID = 27;
    static readonly MAJOR_SYMBOL_ID = 28;
    static readonly GRAND_SYMBOL_ID = 29;
    static readonly GOLD_COIN_START_SYMBOL_ID = 13;
    static readonly GOLD_COIN_END_SYMBOL_ID = 25;
    static readonly SILVER_WILD_SYMOL_ID = 0;
    static readonly GOLDEN_WILD_SYMOL_ID = 30;
}